import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useStore } from '../../store/useStore';

const ICONS = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
  warning: AlertTriangle,
};

const COLORS = {
  success: 'border-desktop-success/40 text-desktop-success',
  error: 'border-desktop-error/40 text-desktop-error',
  info: 'border-desktop-info/40 text-desktop-info',
  warning: 'border-desktop-warning/40 text-desktop-warning',
};

export function NotificationToasts() {
  const notifications = useStore((s) => s.notifications);
  const removeNotification = useStore((s) => s.removeNotification);

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 w-80">
      {notifications.map((n) => {
        const Icon = ICONS[n.type];
        return (
          <div
            key={n.id}
            className="animate-slide-down glass rounded-xl p-4 flex items-start gap-3 shadow-xl"
          >
            <Icon className={`w-5 h-5 mt-0.5 shrink-0 ${COLORS[n.type]}`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-desktop-text">{n.title}</p>
              <p className="text-xs text-desktop-text/70 truncate">{n.message}</p>
            </div>
            <button
              onClick={() => removeNotification(n.id)}
              className="text-desktop-text/50 hover:text-desktop-text transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}